import React from 'react';
import util from 'Utils/commonUtil';

class ChangeShipmentImage extends React.PureComponent {
    componentWillMount() {
        if (window.isBindLazyLoadScrollEvent) return;

        window.addEventListener('scroll', this.onScroll);
        window.isBindLazyLoadScrollEvent = true;
    }

    onScroll = () => {
        window.lazyLoadList &&
            window.lazyLoadList.forEach((item) => {
                let img = new Image();
                img.src = item.url;
                img.onload = () => {
                    if (item.elementNode) {
                        item.elementNode.src = item.url;
                    }
                    item.loaded = true;
                };
                img.onerror = () => {
                    item.loaded = true;
                };

                window.clearTimeout(window.clearLazyLoadImageTimer);
                window.clearLazyLoadImageTimer = window.setTimeout(() => {
                    window.lazyLoadList = window.lazyLoadList || [];

                    for (let i = 0; i < window.lazyLoadList.length; i++) {
                        if (window.lazyLoadList[i].loaded) {
                            window.lazyLoadList.splice(i--, 1);
                        }
                    }
                }, 1000);
            });
    };

    getElement = (element) => {
        window.lazyLoadList = window.lazyLoadList || [];

        window.lazyLoadList.push({
            elementNode: element,
            url: util.getImageRoot(this.props.src) + this.props.src,
        });
        this.onScroll();
    };

    render() {
        return (
            <img
                ref={this.getElement}
                src={new URL('Images/NoImage.png', import.meta.url).href}
                id={this.props.id}
                className={this.props.classname}
                alt={this.props.alt}
            />
        );
    }
}

export default ChangeShipmentImage;
